<template>
  <div class="">
    <va-button @click="showNewCard = !showNewCard">New Coupon</va-button>
    <CouponCard
      v-if="showNewCard"
      @reload="reload()"
      @cancel="cancelNewCoupon()"
      add
    />
    <CouponCard
      @reload="reload()"
      v-for="(item, index) in localStore.coupons"
      :key="index"
      :coupon="item"
    />
  </div>
</template>

<script>
import CouponCard from './couponCard'

export default {
  name: 'CouponPage',
  data () {
    return {
      modified: false,
      showNewCard: false,
      localStore: {
        type: Object,
        required: false,
        default: { title: 'No Store', coupons: [] }
      }
    }
  },
  components: {
    CouponCard
  },
  methods: {
    cancelNewCoupon: function () {
      this.$store.commit('setLoading', false)
      this.showNewCard = false
    },
    newCouponAction: function () {
      this.showNewCard = true
    },
    reload: async function () {
      console.log('Reloading the list')
      await this.$store.dispatch('reloadStores')
      this.localStore = this.$store.getters.currentStore
      this.showNewCard = false
    }
  },
  mounted: function () {
    // TODO: FIgure how to handle this on reload, maybe store in vuex
    this.localStore = this.$store.getters.currentStore

    if (this.localStore.id === -1) {
      // Reset localstore so that the console doesn't complain
      this.localStore = { title: 'No Store', coupons: [] }
      this.$router.push({ name: 'stores' })
    }
  }
}
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}

.card {
  background-color: #fcfcfc;
}
</style>
